import request from './request'

/**
 * 角色列表
 * @param {object} params - 查询参数
 * @param {string} [params.name] - 角色名称
 * @param {string} [params.roleKey] - 角色Key
 * @param {number} [params.status] - 状态
 */
export function getRoles(params = {}) {
  return request.get('/system/roles', { params })
}

/**
 * 获取角色详情
 * @param {number} id - 角色ID
 */
export function getRole(id) {
  return request.get(`/system/roles/${id}`)
}

/**
 * 新增角色
 * @param {object} data - 角色信息
 * @param {string} data.name - 角色名称
 * @param {string} data.roleKey - 角色Key
 * @param {number} [data.dataScope] - 数据范围：1-全部，2-本部门，3-本部门及以下，4-自定义
 * @param {number} [data.status] - 状态：0-禁用，1-启用
 */
export function createRole(data) {
  return request.post('/system/roles', data)
}

/**
 * 修改角色
 * @param {number} id - 角色ID
 * @param {object} data - 角色信息
 * @param {number} data.id - 角色ID
 * @param {string} data.name - 角色名称
 * @param {string} data.roleKey - 角色Key
 * @param {number} [data.dataScope] - 数据范围
 * @param {number} [data.status] - 状态
 */
export function updateRole(id, data) {
  return request.put(`/system/roles/${id}`, data)
}

/**
 * 删除角色
 * @param {number} id - 角色ID
 */
export function deleteRole(id) {
  return request.post(`/system/roles/${id}/delete`)
}

/**
 * 获取角色下的用户ID列表
 * @param {number} id - 角色ID
 */
export function getRoleUserIds(id) {
  return request.get(`/system/roles/${id}/users`)
}

/**
 * 为用户分配角色
 * @param {number} userId - 用户ID
 * @param {object} data - 角色分配信息
 * @param {number[]} data.roleIds - 角色ID列表
 */
export function grantRolesToUser(userId, data) {
  return request.post(`/system/roles/${userId}/users`, data)
}

/**
 * 获取角色数据权限
 * @param {number} id - 角色ID
 */
export function getRoleDataScope(id) {
  return request.get(`/system/roles/${id}/data-scope`)
}

/**
 * 保存角色数据权限
 * @param {number} id - 角色ID
 * @param {object} data - 数据权限信息
 * @param {number} data.roleId - 角色ID
 * @param {number} data.dataScope - 数据范围：1-全部，2-本部门，3-本部门及以下，4-自定义
 * @param {number[]} [data.deptIds] - 自定义数据范围的部门ID列表
 */
export function saveRoleDataScope(id, data) {
  return request.put(`/system/roles/${id}/data-scope`, data)
}

/**
 * 获取所有数据权限资源列表（包含禁用的）
 */
export function getAllDataScopeResources() {
  return request.get('/system/data-scope/resources/all')
}

/**
 * 保存数据权限资源配置
 * @param {object} data - 资源配置信息
 * @param {number} [data.id] - 资源ID（更新时必填）
 * @param {string} data.resourceCode - 资源编码
 * @param {string} data.resourceName - 资源名称
 * @param {string} data.deptColumn - 部门字段名
 * @param {string} data.userColumn - 用户字段名
 * @param {string} [data.description] - 资源描述
 * @param {number} [data.sort] - 排序号
 * @param {number} [data.status] - 状态：0-启用，1-禁用
 */
export function saveDataScopeResource(data) {
  return request.post('/system/data-scope/resources', data)
}

/**
 * 删除数据权限资源配置
 * @param {number} id - 资源ID
 */
export function deleteDataScopeResource(id) {
  return request.delete(`/system/data-scope/resources/${id}`)
}
